<template>
  <div>
    <el-breadcrumb separator=">" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/backHome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>新闻类型</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form ref="form" :model="queryForm" :inline="true">
      <el-form-item>
        <el-button type="primary" @click="childAdd">新增</el-button>
      </el-form-item> 
    </el-form>
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="新闻类型" name="first">
        <el-table
          :data="studentData"
          stripe
          style="width: 100%">

          // index
          <el-table-column
            type="index"
            width="50">
          </el-table-column>

          // 新闻类型
          <el-table-column
            prop="type_name"
            label="新闻类型"
            width="180"
            align="center">
          </el-table-column> 
          
          // 新闻类型英文
          <el-table-column
            prop="type_name_en"
            label="新闻类型"
            width="180"
            align="center">
          </el-table-column> 
          // 新闻类型id
          <!-- <el-table-column
            prop="id"
            label="新闻类型id"
            width="180"
            align="center">
          </el-table-column>   -->
          
          //权重
          <el-table-column
            label="权重"
            prop="order"
            width="80"
            align="center">
          </el-table-column>
          
          //操作
          <el-table-column label="操作" >
            <template slot-scope="scope">
              <el-button type="success" size="small" @click="compile(scope.row)">编辑</el-button>
              <el-button type="danger" size="small" @click="del(scope)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane> 
    </el-tabs> 
    
    <Backfooter></Backfooter>
  </div>
</template>
<script>
import Backfooter from '../../components/dashu/backfooter';
export default {
  components:{Backfooter,},
  data () {
    return{
        pageVal:1,
        pageSize:5,
        currentPage: 1,
        type: 1,
        id:'',
        dataF:'',
        total: 0,
        queryForm: {
        keyword: '',
      },
      activeName: 'first',
      studentData: [
        { 
          order:0,
          content: '',
          address: '',
          name:'',
          email: '',
          type:'',
          status:''
        },
      ],
      flag:1, 
      headers:{
      Authorization: ''
       }, 
    }
  },
  methods: {
    getList(){
       this.$http.post('/admin/dashu/news/newType/getList', { 
        }).then( (res)=> {
      //  console.log(res.data.data)
        var code=res.data.code;
        if(code===0){
        this.studentData=res.data.data.list;
        this.total=res.data.data.total
        }
      }).catch(function (error) {
        //  console.log(error);
     });
    },
    childAdd () {
      // this.childVisible = true
      // this.flag=1;
      this.$router.push({name: 'backCaseAdd', query: {'type': 'backRecipe'}})
    },
    handleClick(tab, event) {
     this.type=Number(tab.index)+1
     this.getList();
    }, 
    compile(row) {
      this.$router.push({name: 'backCaseEdit', query: {'type': 'backRecipe', 'id': row.id}})
    },
    del (row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // console.log(row)
          this.id=row.row.id
          this.$http.post('/admin/dashu/news/newType/delete', {
           id:this.id
      }).then( (res)=> {
        var code=res.data.code;
        if(code===0){
           this.$message({
             type: 'success',
             message: '删除成功!'
        });
         this.getList()
        }
      }).catch(function (error) {
        //  console.log(error);
     });
  }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },  

  },
  created(){
     this.headers.Authorization= window.localStorage.getItem("user_token");
     this.getList();
  },
  computed: {
    getUeData() {
      return this.$store.state.ueData;
    }
  },
  watch: {
    getUeData:function(old,newd){
      this.dataF = old;
    }
  }
}
</script> 

<style scoped>
.el-pagination{
  text-align: center;
  margin-top: 50px;
}
</style>


// WEBPACK FOOTER //
// src/pages/backPages/newtype.vue